<template>
    <div class="ui-content dashboard leader-sub">
        <div class="readymadetest-name-search">
            <div class="search-test-name">
                <v-text-field
                  v-model="testName"
                  @keydown="onSearchTest()"
                  label="Test Name"
                  dense
                  outlined
                  hide-details
                  append-icon="search"
                  autocomplete="off"
                ></v-text-field>
            </div>
        </div>
        <div class="user leaderboard-tab" v-if="tTypes && tTypes.length">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab
                    v-for="(tType) in tTypes"
                    :key="tType.value"
                    :href="'#' + tType.value"
                >{{ tType.text }}
                </v-tab>
            </v-tabs>
        </div>
        <v-card class="mx-auto normal-card">
            <div class="data-table-section prev-test-tb">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onSortChange="onSortChange"
                            :orderBy="orderBy"
                            :onHeaderAction="onHeaderAction"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.name">
                                <td class="text-center" @click="gotoTest(item)">
                                    {{item.test_name}}
                                    <v-icon v-if="!item.is_free && !hasMasterPyqModule" small class="ml-2">mdi-lock</v-icon>
                                </td>
                                <td class="text-center">{{item.duration}}</td>
                                <!-- <td class="text-center">{{item.test_sub_type_name}}</td> -->
                                <td class="text-center">{{item.target_name}}</td>
                                <td class="text-center">{{item.exam_year}}</td>
                                <td class="text-center cursor-pointer download-icon" v-if="item.is_free || hasMasterPyqModule">
                                    <v-img class="loader-img" src="../../../assets/img/loading.gif" v-if="item.status == downloadStatus.IN_PROGRESS"
                                    ></v-img>
                                    <v-btn
                                      v-else
                                      class="download-btn-cp3"
                                      color="transparent"
                                      depressed
                                      @click="downloadTest(item)"
                                    >
                                    <v-img
                                        width="23px"
                                        src="../../../assets/img/download.svg"
                                      ></v-img>
                                    </v-btn>
                                </td>
                                <td class="text-center cursor-pointer download-icon" v-if="!item.is_free || !hasMasterPyqModule">
                                   
                                </td>
                            </tr>
                            <tr v-if="items.length === 0">
                                <td colspan="6" class="text-center">No test found</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div class="btm-test-prev-test">Click on a test name to start answering that test</div>
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left"></div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
    
</template>

<script>
import { mapActions, mapState } from "vuex";
import { detect } from "detect-browser";
import constants from "@/utils/constants";
import { showUpgradeModal } from "@/utils/upgradeUtils";

export default {
    name: "Onlinepyt",
    mounted() {
        this.browserInfo = detect();
        this.setupTabsByTarget();
        this.getSubTypes();
        this.loadExamYears();
        this.downloadStatus = constants.DOWNLOAD_STATUS;
        this.requestGetTestsList();
        this.checkDownloadUpdate();
        this.checkMasterPyqModule();
    },
    data() {
        return {
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tab: null,
            headers: [
                {
                    text: "Test Name",
                    value: "test_name",
                    class: "text-center"
                },
                {
                    text: "Duration(Min)",
                    value: "duration",
                    class: "text-center",
                    hideSort: true
                },
                // {
                //     text: "Test Sub Type",
                //     value: "selectedSubTestTypes",
                //     class: "text-center",
                //     allText: "All Test Subtypes"
                // },
                {
                    text: "Target Exam",
                    value: "target_exam",
                    class: "text-center",
                    hideSort: true
                },
                {
                    text: "Year",
                    value: "exam_year",
                    type: "multidropdown",
                    options: [],
                    class: "text-center",
                    allText: "All Years",
                    hideSort: true
                },
                { text: "", value: "", type: "blank", class: "int-120" }
            ],
            items: [],
            orderBy: {
                field: "test_name",
                order: "ASC"
            },
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            alertBoxData: null,
            status: false,
            cComponent: "",
            modalwidth: null,
            browserInfo: null,
            testName: null,
            selectedSubTestTypes: [],
            subTestTypes: [],
            typetimeout: null,
            tTypes: [],
            selectedExamYears: [],
            isApiCall: true,
            downloadStatus: {},
            requestIds: [],
            testStatusTimeout: 0,
            toasts: {},
            hasMasterPyqModule: false
        };
    },
    computed: {
        ...mapState("userStore", ["user"]),
        TARGET_EXAMS() {
            return constants.TARGET_EXAMS;
        },
        TEST_TYPE() {
            return constants.TEST_TYPE;
        },
        UNSUPPROTED_BROWSERS() {
            return constants.UNSUPPROTED_BROWSERS;
        }
    },
    methods: {
        ...mapActions({
            getTestList: "testStore/getTestList",
            getTestSubTypes: "utilStore/getTestSubTypes",
            getExamYears: "utilStore/getExamYears",
            testAttempted: "testStore/testAttempted",
            downloadTestPaper: "testStore/downloadTest",
            deleteDownloadData: "testStore/deleteDownloadData",
            getDownloadStatus: "testStore/getDownloadStatus",
            getPriceDetails: "userStore/getPriceDetails",
            getTestTarget: "utilStore/getTestTarget",
        }),
        checkMasterPyqModule() {
            const userDetails = this.user ?  this.user : JSON.parse(localStorage.getItem('user') || '{}');
            const subscriptionDetails = userDetails.subscription_details || [];
            const productId = this.getMasterPyqProductId();
            this.hasMasterPyqModule = subscriptionDetails.some(sub => {
                if (sub.product_id && sub.product_id.includes(productId)) {
                    return true;
                }
                return false;
            });
        },
        getMasterPyqProductId() {
            // if (this.user && this.user.batch_name === '2026') {
            //     return constants.MODULES.MASTERPYQ26;
            // } else {
            //     return constants.MODULES.MASTERPYQ27      ;
            // }

             if (this.user && this.user.batch_name === '2026') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return constants.MODULES.MASTERPYQJEE26;
        } else {
          return constants.MODULES.MASTERPYQNEET26;
        }
      } else if (this.user && this.user.batch_name === '2027') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return constants.MODULES.MASTERPYQJEE27;
        } else {
          return constants.MODULES.MASTERPYQNEET27;
        }
      } else if (this.user && this.user.batch_name === '2028') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return constants.MODULES.MASTERPYQJEE28;
        } else {
          return constants.MODULES.MASTERPYQNEET28;
        }
      }
        },
        showUpgradeConfirmationModal() {
            showUpgradeModal(this);
        },
        showOrderConfirmation(priceDetails) {
            const productId = this.getMasterPyqProductId();
            this.cComponent = "components/student/UpgradeToGold/GstChargesPopUp";
            this.modalwidth = "50px";
            this.status = true;
            this.alertBoxData = {
                prodObj: priceDetails.prodObj || [{
                    id: productId,
                    name: 'Master Previous Years Questions (PYQs)',
                    group_name: 'MASTERPYQ',
                    price: priceDetails.total_product_amount || 0
                }],
                priceDetails: priceDetails
            };
        },
        setupTabsByTarget() {
            const targetExamId = this.user && this.user?.target_exam?.exam_id ? this.user.target_exam.exam_id : null;
            
            if (targetExamId === constants.TARGET_EXAM_GROUPS.MEDICAL) {
                this.tTypes = constants.TARGET_EXAM_TABS[571];
            } else if (targetExamId === constants.TARGET_EXAM_GROUPS.ENGINEERING) {
                this.tTypes = constants.TARGET_EXAM_TABS[572];
            }
            // REWISE_VAS CR (2026-10-02): show an exam only when at least one P.Y. paper exists for
            // it — `/ref/get-test-targets` with `with_pyt_count` (server-cached 6 h). The hardcoded
            // "Remove MHCET and OTHERS" below was the manual version of this; it stays as the
            // fallback when the lookup fails, so the page never shows zero tabs.
            const baseTabs = this.tTypes;
            this.tTypes = baseTabs.filter(t => t.value !== 9 && t.value !== 11 && t.value !== 12 && t.value !== 13); // Remove MHCET and OTHERS
            this.tab = this.tTypes[0].value;
            this.getTestTarget({ with_pyt_count: true })
                .then(targets => {
                    const withPapers = new Set((targets || []).filter(t => (t.pyt_test_count || 0) > 0).map(t => Number(t.id)));
                    const kept = baseTabs.filter(t => withPapers.has(t.value));
                    if (kept.length === 0) return; // keep the fallback rather than show no tabs
                    this.tTypes = kept;
                    if (!kept.some(t => t.value === this.tab)) {
                        this.tab = kept[0].value;
                    }
                })
                .catch(() => {}); // fallback already applied
        },
        onClose(data) {
            this.status = data.status;
            
            // Handle upgrade confirmation modal response
            if (data.openPaymentModal) {
                this.cComponent = 'components/student/UpgradeToGold/GstChargesPopUp';
                this.modalwidth = '500px';
                this.status = true;
                this.alertBoxData = data.paymentData;
                return;
            }
            
            if (data && data.redirectTo) {
                this.redirectTo(data.redirectTo);
            }
            if (data && data.data) {
                let domainUrl = process.env.VUE_APP_API_URL;
                let tab = "offline";
                
                let token = sessionStorage.getItem("auth_token");
                let api = "download-test";
                let query = `custom=${tab}&token=${token}&column=2&isRoughWork=false&pageBreak=true`;
                if (data.download_option === 2) {
                    api = "download-answer-key";
                    query = `token=${token}`;
                } else if (data.download_option === 3) {
                    api = "download-test-solution";
                    query = `custom=${tab}&token=${token}`;
                } else if (data.download_option === 4) {
                    api = "download-omr";
                    query = `token=${token}`;
                }
                let url = domainUrl + `/test/${api}/${data.data.test_id}?${query}`;
                if (data.download_option === 2) {
                    window.open(url, "_blank");
                } else {
                    this.downloadTestResource(
                        `test/${api}/${data.data.test_id}?${query}`,
                        data.data
                    );
                }
            }
        },
        checkBrowserSupport() {
            if (!this.browserInfo || !this.browserInfo.name) return false;
            let browserName = this.browserInfo.name;
            let nAgent = navigator.userAgent.toLowerCase();
            let isSupported = true;
            this.UNSUPPROTED_BROWSERS.forEach((browser) => {
                if (nAgent.includes(browser)) {
                    isSupported = false;
                }
            });
            if (
                isSupported &&
                (browserName == "firefox" ||
                    browserName == "chrome" ||
                    browserName == "safari" ||
                    browserName == "crios" ||
                    browserName == "fxios" ||
                    browserName == "ios")
            ) {
                return true;
            }
            return false;
        },
        gotoTest(test) {
            // Check if test is locked
            if (!test.is_free && !this.hasMasterPyqModule) {
                this.showUpgradeConfirmationModal();
                return;
            }
            
            if (this.checkBrowserSupport()) {
                let routeName = this.$route.name;
                localStorage.setItem("previousRoute", routeName);
                let reqData = {
                    test_institute_id: test.test_institute_id,
                    student_id: this.user.id,
                }
                this.testAttempted(reqData)
                .then((response) =>{
                    if(response){
                        localStorage.setItem("previousPath", this.$route.path);
                        this.$router.push({
                            name: "instructions-about-test",
                            params: {
                                test_id: test.id,
                                test_institute_id: test.test_institute_id,
                            },
                        })
                    }
                })
                .catch(() => {
                }); 
            } else {
                this.cComponent = "components/common/BrowserSupport";
                this.modalwidth = "700px";
                this.status = true;
                this.alertBoxData = { persistent: false };
            }
        },
        onPageChange(e) {
            this.currentPage = e;
            if (!this.isApiCall) {
                this.requestGetTestsList();
            }
        },
        onSortChange() {
            this.currentPage = 1;
            if (!this.isApiCall) {
                this.requestGetTestsList();
            }
        },
        onHeaderAction(e) {
            if (e.data && e.data.selectedItems) {
                if (e.header.value === 'exam_year') {
                    this.selectedExamYears = e.data.selectedItems;
                } else {
                    this[e.header.value] = e.data.selectedItems;
                }
                this.currentPage = 1;
                this.requestGetTestsList();
            }
        },
        requestGetTestsList() {
            let reqData = {
                isReadyMadeTest: true,
                orderBy: this.orderBy,
                pagination: { page: this.currentPage, pageSize: this.pageSize },
                test_types: [this.TEST_TYPE.PREVIOUS_YEAR],
                target_exam: this.tab,
            };
            if (this.selectedSubTestTypes && this.selectedSubTestTypes.length) {
                reqData.test_sub_types = this.selectedSubTestTypes;
            }
            if (this.selectedExamYears && this.selectedExamYears.length) {
                reqData.exam_years = this.selectedExamYears;
            }
            if (this.testName) {
                reqData.test_name = this.testName
            }
            this.$root.showLoader = true;
            this.getTestList(reqData)
                .then(response => {
                    if (response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    }
                    this.$root.showLoader = false;
                    this.items = response.list;
                    this.isApiCall = false;
                    this.totalPages = response.pagination.pageCount;
                })
                .catch(() => {
                    this.$root.showLoader = false;
                });
        },
        getSubTypes() {
            const postData = { main_types: [this.TEST_TYPE.PREVIOUS_YEAR] };
            this.getTestSubTypes(postData)
                .then((response) => {
                    this.subTestTypes = response.map(x => ({
                        text: x.name,
                        value: x.id,
                        checked: this.selectedSubTestTypes && this.selectedSubTestTypes.includes(x.id) ? true : false
                    }));
                    this.headers[2].options = this.subTestTypes;
                })
                .catch(() => {
                });
        },
        loadExamYears() {
            this.getExamYears({ targets: [this.tab] })
                .then((response) => {
                    if (response && response.length) {
                        this.headers[3].options = response.map(function(year) {
                            return { text: String(year), value: year, checked: false };
                        });
                    } else {
                        this.headers[3].options = [];
                    }
                })
                .catch(function() {});
        },
        onSearchTest() {
            this.resetFields();
            if (this.typetimeout) {
                clearTimeout(this.typetimeout);
            }
            this.typetimeout = setTimeout(() => {
                if (!this.isApiCall) {
                    this.requestGetTestsList();
                }
            }, 800);
        },
        resetFields() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.totalPages = 1;
        },
        downloadTest(item) {
            this.cComponent = "components/coordinator/Tests/DownloadTestPopup";
            this.alertBoxData = {
                ...item,
                test_id: item.id,
                test_institute_id: item.test_institute_id,
                tab: 'Online',
                isOnlineOfflineTest: false,
            };
            this.status = true;
            this.modalwidth = "550px";
        },
        downloadTestResource(url, test) {
            this.items = this.items.map((item) => {
                if (item.id === test.test_id) {
                    item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS;
                }
                return item;
            });
            this.toasts[test.test_id] = this.$toasted.success("PDF creation under progress. Please do not leave this page", {icon: 'info', duration: null});

            this.downloadTestPaper(url)
                .then((res) => {
                    this.items = this.items.map((item) => {
                        if (item.id === test.test_id) {
                            item.request_id = res.request_id;
                        }
                        return item;
                    });
                    this.requestIds.push(res.request_id);
                    this.$forceUpdate();
                    this.checkDownloadUpdate();
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        checkDownloadUpdate() {
            if (this.testStatusTimeout) {
                clearInterval(this.testStatusTimeout);
                this.testStatusTimeout = null;
            }
            if (this.requestIds && this.requestIds.length) {
                this.testStatusTimeout = setInterval(() => {
                    this.getTestDownloadStatus();
                }, 10 * 1000);
            }
        },
        getTestDownloadStatus() {
            const reqData = {
                request_ids: this.requestIds,
                download_types: [
                    constants.DOWNLOAD_TYPES.TEST_PAPER,
                    constants.DOWNLOAD_TYPES.SOLUTION_PAPER,
                    constants.DOWNLOAD_TYPES.OMR,
                ],
            };
            this.getDownloadStatus(reqData)
                .then(async(res) => {
                    const arr = [];
                    this.items.map((item) => {
                        const data = res.find((r) => r.request_id == item.request_id);
                        if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
                            item.url = data.url;
                            item.status = data.status;
                            if(item.url){
                                arr.push({
                                    url: data.url,
                                    request_id: data.request_id
                                });
                            }
                            this.requestIds = this.requestIds.filter(
                                (rid) => rid !== data.request_id
                            );
                            this.toasts[item?.id]?.goAway(0);
                            delete this.toasts[item?.id];
                            this.$toasted.success(`Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`, {icon: 'info'});
                        }
                    });
                    for (let i = 0; i < arr.length; i++) {
                        const item = arr[i];
                        await this.downloadTestURL(item);
                        
                        await new Promise(resolve => {
                            console.log('Starting delay');
                            setTimeout(() => {
                                resolve();
                            }, 1000);
                        });
                    }
                    if (!this.requestIds || !this.requestIds.length) {
                        clearInterval(this.testStatusTimeout);
                        this.testStatusTimeout = null;
                    }
                })
                .catch((err) => {
                });
        },
        downloadTestURL(item) {
            if (item.url && item.request_id) {
                window.open(item.url, "_self");
                const reqData = {
                    request_id: item.request_id,
                };
                
                this.items = this.items.map((e) => {
                    if(e.request_id == item.request_id) {
                        e.status = constants.DOWNLOAD_STATUS.COMPLETED;
                    }
                    return e;
                });
                setTimeout(() => {
                    this.deleteDownloadData(reqData)
                        .then((res) => {
                        })
                        .catch((err) => {});
                }, 5000);
            }
        },
    },
    watch: {
        selectedSubTestTypes(val) {
            if (val) {
                this.resetFields();
                if (!this.isApiCall) {
                    this.requestGetTestsList();
                }
            }
        },
        tab(val, oldVal) {
            if(oldVal) {
                this.selectedSubTestTypes = [];
                this.selectedExamYears = [];
                this.resetFields();
                this.loadExamYears();
                this.requestGetTestsList();
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.testStatusTimeout);
        this.testStatusTimeout = null;
    }
};
</script>



